<template>
  <v-app-bar app color="secondary" flat height="56">
    <v-app-bar-nav-icon
      v-if="$vuetify.breakpoint.smAndDown"
      color="primary"
      @click="$emit('toggle-drawer')"
    />

    <span class="app-title primary--text ml-2">ROWING MANAGER</span>

    <v-spacer />

    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-btn
        v-for="item in navItems"
        :key="item.route"
        text
        :color="$route.name === item.name ? 'primary' : 'panel_primary'"
        :disabled="item.requiresRegatta && !selectedRegattaId"
        class="mx-1"
        :to="item.route"
      >
        <v-icon small left>{{ item.icon }}</v-icon>
        {{ item.label }}
      </v-btn>
    </template>

    <v-spacer />

    <v-menu offset-y left>
      <template v-slot:activator="{ on }">
        <v-btn icon color="panel_primary" v-on="on">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>
      <v-list dense class="secondary">
        <v-list-item v-if="userName" disabled>
          <v-list-item-title class="text-caption">{{ userName }}</v-list-item-title>
        </v-list-item>
        <v-divider v-if="userName" />
        <v-list-item @click="$store.dispatch('logOut')">
          <v-list-item-icon><v-icon small>mdi-logout</v-icon></v-list-item-icon>
          <v-list-item-title>Sign out</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'NavigationBar',
  computed: {
    ...mapState(['userName']),
    ...mapGetters(['getSelectedRegattaId']),
    selectedRegattaId() {
      return this.getSelectedRegattaId
    },
    navItems() {
      return [
        { label: 'Regattas', name: 'Regattas', route: '/regattas', icon: 'mdi-calendar-star', requiresRegatta: false },
        { label: 'Results', name: 'Results', route: '/results', icon: 'mdi-podium', requiresRegatta: true },
        { label: 'Lane Analysis', name: 'LaneAnalysis', route: '/lane-analysis', icon: 'mdi-chart-bar', requiresRegatta: true },
        { label: 'Live Races', name: 'LiveRaces', route: '/live', icon: 'mdi-broadcast', requiresRegatta: true },
        { label: 'Splits', name: 'SplitsAnalysis', route: '/splits', icon: 'mdi-chart-timeline-variant', requiresRegatta: true },
        { label: 'Benchmark', name: 'BenchmarkAnalysis', route: '/benchmark', icon: 'mdi-trophy-variant-outline', requiresRegatta: true },
        { label: 'Athletes', name: 'AthleteResults', route: '/athlete-results', icon: 'mdi-account-group-outline', requiresRegatta: false }
      ]
    }
  }
}
</script>

<style scoped>
.app-title {
  font-family: Verdana, Geneva, sans-serif;
  font-weight: bold;
  font-style: italic;
  font-size: 1.1rem;
  letter-spacing: 0.05em;
}
</style>
